<template>
  <v-app>
    <v-overlay v-if="frameLoading || !frame" z-index="20">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <template v-show="!frameLoading && frame">
      <v-app-bar v-if="!frameLoading && frame" app :shrink-on-scroll="false" color="white">
        <img v-if="frame.logo" :src="frame.logo" class="mr-6" style="max-height:100%; max-width: 200px;"/>
        <v-toolbar-title v-else-if="frame.title"

                         class="primary--text mr-6">{{ frame.title }}
        </v-toolbar-title>
        <template v-if="!isSingleRoomEvent && $route.name !=='Login' && $vuetify.breakpoint.mdAndUp && (event || room)">
          <v-btn v-if="frame.display_lobby" :to="`/${$route.params.url}`" text exact color="primary"
                 class="subtitle-1 font-weight-light ml-1"
                 style="text-transform: none">
            {{ $t( 'frame.navigation.foyer' ) }}
          </v-btn>
          <v-btn v-for="(room, idx) in frame.rooms" :key="idx" color="primary"
                 :to="`/${$route.params.url}/room/${room.id}`" text exact
                 class="subtitle-1 font-weight-light ml-1"
                 style="text-transform: none">
            {{ room.title }}
          </v-btn>
          <v-btn v-if="frame.sponsors_in_extra_view" color="primary"
                 :to="`/${$route.params.url}/sponsors`" text exact
                 class="subtitle-1 font-weight-light ml-1"
                 style="text-transform: none">
            {{
              frame.sponsor_heading ? frame.sponsor_heading : $t( 'foyer.sponsor_heading' )
            }}
          </v-btn>
          <v-btn v-if="frame.posters && frame.posters.length > 0" color="primary"
                 :to="`/${$route.params.url}/posters`" text exact
                 class="subtitle-1 font-weight-light ml-1"
                 style="text-transform: none">
            {{
              frame.poster_heading ? frame.poster_heading : $t( 'foyer.poster_heading' )
            }}
          </v-btn>
        </template>
      </v-app-bar>
      <v-main ref="main" @resize="footerVisible">
        <template v-if="eventLoading || formLoading || roomLoading || sponsorsLoading || posterLoading || foyerLoading || docCheckLoginLoading">
          <v-progress-linear indeterminate></v-progress-linear>
        </template>
        <router-view v-if="!frameLoading && frame"/>
      </v-main>
    </template>
    <v-footer :dark="dark && $vuetify.breakpoint.mdAndUp"
              :color="$vuetify.breakpoint.smAndDown ? '#f2f4f5' : 'primary'" absolute ref="footer"
              app v-if="!frameLoading && frame">
      <v-card :color="$vuetify.breakpoint.smAndDown ? '#f2f4f5' : 'primary'" elevation="0" width="100%">
        <v-card-text>
          <v-row>
            <v-col cols="auto" class="py-0" v-if="frame.privacy_policy_link || frame.privacy_policy">
              <a v-if="frame.privacy_policy_link" :href="frame.privacy_policy_link"
                 :class="dark && $vuetify.breakpoint.mdAndUp ? 'white--text': 'black--text'"
                 target="_blank">{{ $t( 'frame.footer.privacy_policy' ) }}</a>
              <footer-dialog v-else :title="$t('frame.footer.privacy_policy')" :text="frame.privacy_policy"/>
            </v-col>
            <v-col cols="auto" class="py-0" v-if="frame.legal_notice_link || frame.legal_notice">
              <a v-if="frame.legal_notice_link" :href="frame.legal_notice_link"
                 :class="dark && $vuetify.breakpoint.mdAndUp ? 'white--text': 'black--text'"
                 target="_blank">{{ $t( 'frame.footer.legal_notice' ) }}</a>
              <footer-dialog v-else :title="$t('frame.footer.legal_notice')" :text="frame.legal_notice"/>
            </v-col>
            <v-col cols="auto" class="py-0" v-if="frame.terms_and_conditions_link || frame.terms_and_conditions">
              <a v-if="frame.terms_and_conditions_link" :href="frame.terms_and_conditions_link"
                 :class="dark && $vuetify.breakpoint.mdAndUp ? 'white--text': 'black--text'"
                 target="_blank">{{ $t( 'frame.footer.terms_and_conditions' ) }}</a>
              <footer-dialog v-else :title="$t('frame.footer.terms_and_conditions')"
                             :text="frame.terms_and_conditions"/>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-footer>
    <v-bottom-navigation
        app
        id="bottomnav"
        v-if="!frameLoading && frame && !(isSingleRoomEvent) && $route.name!=='Login' && $vuetify.breakpoint.smAndDown"
        background-color="primary"
        :dark="dark"
    >
      <v-btn v-if="frame.display_lobby" :to="`/${$route.params.url}`" exact>
        <span>{{ $t( 'frame.navigation.foyer' ) }}</span>
        <v-icon>mdi-home</v-icon>
      </v-btn>

      <v-menu offset-y top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn :class=" $route.name === 'Room' ? 'v-btn--active' : ''" v-bind="attrs"
                 v-on="on">
            <span>{{ $t( 'frame.navigation.streams' ) }}</span>
            <v-icon>mdi-cast-connected</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-for="(room, idx) in frame.rooms" :key="idx"
                       :to="`/${$route.params.url}/room/${room.id}`" exact
          >
            <v-list-item-content>
              <v-list-item-title>{{ room.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn v-if="frame.sponsors_in_extra_view" :to="`/${$route.params.url}/sponsors`" exact>
            <span>{{
                frame.sponsor_heading ? frame.sponsor_heading : $t( 'foyer.sponsor_heading' )
              }}</span>
        <v-icon>mdi-star</v-icon>
      </v-btn>
      <v-btn v-if="frame.posters && frame.posters.length > 0" :to="`/${$route.params.url}/posters`" exact>
            <span>{{
                frame.poster_heading ? frame.poster_heading : $t( 'foyer.poster_heading' )
              }}</span>
        <v-icon>mdi-presentation</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </v-app>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import gql from 'graphql-tag';
import FooterDialog from '@/components/FooterDialog';


export default {
  name: 'Frame',
  components: { FooterDialog },
  props: {
    url: String,
  },

  mounted ()
  {
    this.footerVisible();
    window.onscroll = this.footerVisible;
    window.onresize = this.footerVisible;
    if ( typeof ResizeObserver !== 'undefined' )
    {
      const resizeObserver = new ResizeObserver( this.footerVisible );
      resizeObserver.observe( this.$refs.main.$el );
    }
    let url = this.url;
    this.setFrameLoading( true );
    this.$apollo.query( {
      query: gql`
                    query eventsFrame($url: String!){
                        eventsFrame(url: $url) {
                            id
                            rooms {
                                id
                                title
                            }
                            sponsors_in_extra_view
                            sponsor_heading
                            poster_heading
                            display_lobby
                            posters {
                                id
                            }
                            language
                            title
                            logo
                            primary_color
                            dark
                            terms_and_conditions
                            terms_and_conditions_link
                            privacy_policy
                            privacy_policy_link
                            legal_notice
                            legal_notice_link
                        }
                }`,
      variables: {
        url: url,
      },
      fetchPolicy: 'network-only',
    } ).then( ( { data } ) =>
    {
      if ( data )
      {
        this.updateFrame( data.eventsFrame );
        this.setFrameLoading( false );
      }
    } );
  },
  methods: {
    ...mapMutations( ['setChatOffset', 'setFrameLoading'] ),
    ...mapActions( ['updateFrame'] ),
    footerVisible ()
    {
      if ( this.$refs.footer && this.$refs.footer.$el )
      {
        let footer = this.$refs.footer.$el.getBoundingClientRect();

        let chatOffset = window.innerHeight - footer.top - ( this.$vuetify.breakpoint.smAndDown ? 56 : 0 );
        this.setChatOffset( chatOffset > 0 ? chatOffset : 0 );
      }
      else
      {
        this.setChatOffset( 0 );
      }
    },
  },
  computed: {
    ...mapState( ['frame',
                  'event',
                  'room',
                  'frameLoading',
                  'eventLoading',
                  'formLoading',
                  'docCheckLoginLoading',
                  'roomLoading',
                  'posterLoading',
                  'sponsorsLoading',
                  'foyerLoading'] ),
    ...mapGetters( ['dark', 'isSingleRoomEvent'] ),
  },
};
</script>

<style scoped>
.theme--light.v-btn:before {
  opacity: 0.12 !important;
}
.theme--light.v-btn--active:hover::before, .theme--light.v-btn--active::before {
  opacity: 0.36 !important;
}
</style>